import React, {useEffect, useRef, useState} from 'react';
import {useStores} from "../../../../stores/Context";
import axios from "axios";
import {useParams} from "react-router-dom";
import ReactQuill, {Quill} from "react-quill";
import BtnPrimary from "../../../../boiteAOutils/BtnPrimary";
import BtnTiertary from "../../../../boiteAOutils/BtnTiertary";
import {observer} from "mobx-react";

const WidgetConsignesContentModify = observer((props) => {
    const {id, ent} = useParams();
    const {widgetStore, consignesStore, bibliothequeImagesStore, sidebarWidgetStore} = useStores();
    const [listTags, setListTags] =useState([]);
    const [listPhotos, setListPhotos] = useState([]);
    const [value, setValue] = useState( props.data.content ?? '');
    const [tagSelected, setTagSelected] = useState(props.data.tag_id ?? '');
    const quillRef = useRef(null);

    console.log('Props : ', props.data)

    useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL + '/api/getTagsByIdTotem/' + widgetStore.idTotem    ,
            { headers: {"Authorization" : `Bearer ${widgetStore.getCookie("current_apiToken")}`} }
        ).then((res) => {
            setListTags(res.data);
        })
    }, []);

    useEffect(() => {
        if (bibliothequeImagesStore.selectedImageModule){
            console.log('test !!! : ', bibliothequeImagesStore.selectedImageModule)
            handleInsertUpdatePhoto(bibliothequeImagesStore.selectedImageModule);
            bibliothequeImagesStore.onResetImageModule();
        }
    }, [bibliothequeImagesStore.selectedImageModule]);

    const handleInsertUpdatePhoto = (imageUrl) => {
        if (quillRef.current) {
            const editor = quillRef.current.getEditor();
            const range = editor.getSelection();

            if (range) {
                editor.insertEmbed(range.index, 'image', process.env.REACT_APP_API_URL+'/uploads/bibliotheque/'+imageUrl);
            } else {
                // Si la sélection n'existe pas, insérer l'image au début de l'éditeur
                editor.insertEmbed(0, 'image', process.env.REACT_APP_API_URL+'/uploads/bibliotheque/'+imageUrl);
            }
        }
    }

    const handleBtnModify = () => {

        axios.post(process.env.REACT_APP_API_URL + '/api/editConsigne', {
                id : props.data.id,
                content: value,
                id_tag: tagSelected
            }    ,
            { headers: {"Authorization" : `Bearer ${widgetStore.getCookie("current_apiToken")}`} }
        ).then((res) => {
            props.onClose();
            props.onUpdate();
        });
    }

    const handleChangeContentEditor = (val) => {
        setValue(val)
    }

    const modules = {
        toolbar: [
            ['image']
        ],
        clipboard: {
            matchVisual: false,
        },
        imageResize: {
            parchment: Quill.import('parchment'),
            modules: ['Resize', 'DisplaySize']
        }
    };
    
    const closeEditMode = () => {
        props.onClose();
        consignesStore.resetViews();
    }

    return (
        <div className={"consigneModifyBody"}>
            <div className={"consigneModifyHeader"}>
                <h3 className={"consigneModifyTitleH3"}>
                    Modifier la consigne
                </h3>
                <div onClick={closeEditMode}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.2363 7.16016L14.8809 12.0004L10.2363 16.8406" stroke="#70787B" stroke-width="2"/>
                        <line x1="14.6973" y1="12.3281" x2="2.43556" y2="12.3281" stroke="#70787B" stroke-width="2"/>
                        <line x1="19.0469" y1="5.39844" x2="19.0469" y2="18.6044" stroke="#70787B" stroke-width="2"/>
                    </svg>
                </div>
            </div>
            <div className={"consigneModifyHeaderSeparateur"}></div>

            <div className={"consigneModifyBodyContent"}>
                <div className={"consigneModifyEditorTagContent"}>

                    <label className={"consigneModifyEditorTagContentLabel"}>Catégorie : </label>
                    <select className={"consigneModifyEditorTagContentInput"} onChange={(e) => setTagSelected(e.target.value)}>
                        {
                            props.data.tag_id ? (<option value={props.data.tag_id}>{props.data.tag_nom}</option>) : ('')
                        }
                        <option value={''}>--- Aucune catégorie ---</option>
                        {
                            listTags.map((data) => (
                                <option value={data.id} key={'T_' + data.id}>{data.nom}</option>
                            ))
                        }
                    </select>
                </div>

                <div className={"consigneModifyEditorContent"}>
                    <label className={"consigneModifyEditorLabel"}>Message :</label>
                    <ReactQuill theme="snow"
                                ref={quillRef}
                                modules={modules}
                                value={value}
                                onChange={(val) => handleChangeContentEditor(val)}
                    />
                </div>

                <div className={"consigneModifyBtnContent"}>
                    <div>
                        <BtnTiertary onClick={() => {
                            bibliothequeImagesStore.handleOpenModuleImage();
                            sidebarWidgetStore.handleOpenSidebarWidget();
                        }}
                                     style={{width: "100%", justifyContent: "left", padding: "8px 16px"}}>
                            <svg width="22" height="21" viewBox="0 0 22 21" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.83301 3.83203H20.1663V17.1654H1.83301V3.83203Z" stroke="#A8B0B3"
                                      strokeWidth="2"/>
                                <path d="M1.83301 16.3333L14.1247 8L20.1663 11.3333" stroke="#A8B0B3" strokeWidth="2"/>
                                <circle cx="6.00033" cy="8.0013" r="0.833333" stroke="#A8B0B3" strokeWidth="2"/>
                            </svg>
                            Mes images
                        </BtnTiertary>
                    </div>
                    <div style={{display: "flex", justifyContent: "space-between", alignItems: "center" ,width: "40%"}}>
                        <button type={"button"} className={"consigneBtnAnnuler"} onClick={() => props.onClose()}>Fermer
                        </button>
                        <BtnPrimary onClick={handleBtnModify}>Valider</BtnPrimary>
                    </div>
                </div>
            </div>

        </div>
    );
});

export default WidgetConsignesContentModify;